/**
 * Valida que un objeto contenga valores para todos sus campos requeridos.
 * 
 * Esta función se usa como validación defensiva para evitar llamadas inválidas
 * a servicios. No está pensada para validaciones de UI.
 *
 * Recorre las entradas del objeto `fields` y verifica que ninguno de los valores
 * sea `null` o `undefined`. Si encuentra campos faltantes, lanza un error con
 * el listado de dichos campos.
 *
 * @param {Object<string, any>} fields - Objeto con los campos a validar. Cada clave representa el nombre del campo y su valor el dato asociado.
 *
 * @throws {Error} Si uno o más campos requeridos están ausentes.
 */
export const validateRequiredFields = (fields) => {
  const missingFields = Object.entries(fields)
    .filter(([, value]) => value === null || value === undefined)
    .map(([key]) => key);

  if (missingFields.length > 0) {
    throw new Error(
      `Missing required fields: ${missingFields.join(', ')}`
    );
  }
};
